import { Subject } from 'rxjs';
const errorSubject = new Subject();
export default errorSubject;
